import React from 'react';
import {useIntl} from 'react-intl';

import validationRules from 'coreUtils/validationRules';

import CheckboxField from 'brandComponents/Form/Subcomponents/CheckboxField';
import Grid from 'brandComponents/Grid';
import Link from 'brandComponents/Link';
import Typography from 'brandComponents/Typography';

import messages from './messages';

import styles from './AuthRegisterFormConsent.module.scss';

const AuthRegisterFormConsent = () => {
	const intl = useIntl();

	return (
		<div className={styles['auth__register-form__consent']}>
			<Typography variant="p" classNames={styles['auth__register-form__consent-title']}>
				{intl.formatMessage(messages.personalDataProcessingTitle)}
			</Typography>

			<Grid.Row>
				<Grid.Column md={12}>
					<CheckboxField
						name="privacyAuthorization"
						classNames="auth__register-form__consent-text"
						label={
							<span>
								{intl.formatMessage(messages.termsAndPolicy, {
									terms: (chunk) => (
										<Link to="/terms-and-conditions-of-use">
											{chunk}
										</Link>
									),
									privacy: (chunk) => (
										<Link to="/privacy-policy">
											{chunk}
										</Link>
									)
								})}
							</span>
						}
						validation={[{rule: validationRules.isTrue, errorMessage: intl.formatMessage(messages.required)}]}
					>
					</CheckboxField>
				</Grid.Column>
			</Grid.Row>

			<Grid.Row>
				<Grid.Column md={12}>
					<CheckboxField
						name="acceptsMarketing"
						classNames="auth__register-form__consent-text"
						label={intl.formatMessage(messages.marketing)}
					>
					</CheckboxField>
				</Grid.Column>
			</Grid.Row>

			<Grid.Row>
				<Grid.Column md={12}>
					<CheckboxField
						name="authorizationDataCollection"
						classNames="auth__register-form__consent-text"
						label={intl.formatMessage(messages.profiling)}
					>
					</CheckboxField>
				</Grid.Column>
			</Grid.Row>
		</div>
	);
};

export default AuthRegisterFormConsent;
